// extracted by mini-css-extract-plugin
export default {"header":"OverviewItem_header__TIrmC","items":"OverviewItem_items__rcJ6L"};